<template>
  <div v-if="search.result">
    <!-- If not in facetRefinementList (Showing all), set value to '' -->
    <FormSelect
      @change="value => handleDropDown(value)"
      :value="search.facetRefinementList[facetKey] || ''"
      :name="name"
      :items="options"
      :emptyFirstOption="false"
      :label="label"
    />
  </div>
</template>

<script>
import FormSelect from '@/components/forms/elements/FormSelect'

export default {
  name: 'UtilDropdownFacet',
  components: {
    FormSelect
  },
  props: {
    search: {
      type: Object,
      required: true
    },
    facetKey: {
      type: String,
      required: true
    },
    moduleName: {
      type: String,
      default: 'search'
    },
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    handleDropDown(value) {
      // If Show All option selected (''). Dispatch toggleFacet with existing value, this will remove from facetRefinementList
      this.$store.dispatch(`${this.moduleName}/toggleFacet`, {
        key: this.facetKey,
        value: value === '' ? this.search.facetRefinementList[this.facetKey] : value
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
